import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../environments/environment';

@Injectable()
export class AuthHeaderInterceptor implements HttpInterceptor {

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ) {
    const token: string = sessionStorage.getItem('access_token');

    if (token) {
        request = request.clone({ headers: request.headers.set('Access_Token', token) });
        request = request.clone({ headers: request.headers.set("X-Xss-Protection", "1; mode=block") });
        request = request.clone({ headers: request.headers.set("X-Frame-Options", "SAMEORIGIN") });
        request = request.clone({ headers: request.headers.set('Access-Control-Allow-Origin', environment.Allow_Origin) }); //www.gebbsrcm.com
    }
    return next.handle(request);
  }
}
